import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Button } from "../components/Button";
import { ErrorMessage } from "../components/ErrorMessage";
import { LoadingIndicator } from "../components/LoadingIndicator";

/**
 * Blocks protected routes until auth bootstrap finishes.
 * Unauthenticated users are sent to /login without flashing protected content.
 */
export function ProtectedRoute() {
  const auth = useAuth();

  if (auth.status === "loading") {
    return (
      <div className="hw-auth-screen">
        <LoadingIndicator label="Проверка сессии…" />
      </div>
    );
  }

  if (auth.status === "error") {
    return (
      <div className="hw-auth-screen">
        <div className="hw-auth-panel">
          <h1 className="hw-auth-panel__brand">Hot Wheels Collection</h1>
          <ErrorMessage>{auth.message}</ErrorMessage>
          <Button
            onClick={() => {
              void auth.retryBootstrap();
            }}
          >
            Повторить
          </Button>
        </div>
      </div>
    );
  }

  if (auth.status !== "authenticated") {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
